var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleWhyYourInternalToolBecameASpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gwhyyourinter",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wwhyyourinter",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F6560",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "owhyyourinter",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#163936"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wwhyyourinter)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#owhyyourinter)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 318,
    width: 124,
    height: 164,
    rx: 58,
    fill: "url(#gwhyyourinter)",
    stroke: "#548A85",
    strokeOpacity: 0.22,
    strokeWidth: 1.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 266,
    width: 228,
    height: 268,
    rx: 76,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.29,
    strokeWidth: 1.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 214,
    width: 332,
    height: 372,
    rx: 94,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.36,
    strokeWidth: 1.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 162,
    width: 436,
    height: 476,
    rx: 112,
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.75,
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 110,
    width: 540,
    height: 580,
    rx: 130,
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.5,
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 110,
    r: 11,
    fill: "#FF4804",
    fillOpacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 110,
    r: 7,
    fill: "#83ADA9",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 690,
    r: 7,
    fill: "#83ADA9",
    fillOpacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 870,
    cy: 690,
    r: 7,
    fill: "#83ADA9",
    fillOpacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 400,
    r: 30,
    fill: "#FF4804"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 400,
    r: 58,
    fill: "none",
    stroke: "#F5F8F7",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleWhyYourInternalToolBecameASpreadsheet);
export default __webpack_public_path__ + "static/media/article-why-your-internal-tool-became-a-spreadsheet.cd0e6202304476b9528f67607995bc6c.svg";
export { ForwardRef as ReactComponent };